import { ColumnDef, flexRenderComponent } from '@tanstack/angular-table';
import { TableButtonCellComponent } from '@core/components/table/table-button-cell/table-button-cell.component';
import { AdminUnpricedItem } from './admin-unpriced.interface';
import { TableDateCellComponent } from '@core/components/table/table-date-cell/table-date-cell.component';
import { TableColorCellComponent } from '@core/components/table/table-color-cell/table-color-cell.component';

interface Props {
  handleRemoveItem: (item: AdminUnpricedItem) => void;
  handleOpenEditModal: (item: AdminUnpricedItem) => void;
}

export const adminUnpricedTableConfig = ({
  handleRemoveItem,
  handleOpenEditModal,
}: Props): ColumnDef<AdminUnpricedItem>[] => [
  {
    accessorKey: 'name',
    id: 'name',
    header: ({ column }) => ({
      content: 'Name',

      onClick: () => column.toggleSorting(),
    }),
    cell: (info) => info.getValue(),
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.loads,
    id: 'loads',
    header: ({ column }) => ({
      content: 'Loads',
      onClick: () => column.toggleSorting(),
    }),
    cell: (cell) => {
      const loads = cell.row.original.loads?.toString() ?? '0';
      return flexRenderComponent(TableColorCellComponent, {
        inputs: { value: loads },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.quality,
    id: 'quality',
    header: ({ column }) => ({
      content: 'Quality',
      onClick: () => column.toggleSorting(),
    }),
    cell: (cell) => {
      return flexRenderComponent(TableColorCellComponent, {
        inputs: { value: cell.row.original.quality },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.first_popup,
    id: 'first_popup',
    header: ({ column }) => ({
      content: 'First Popup',
      onClick: () => column.toggleSorting(),
    }),
    cell: (info) =>
      flexRenderComponent(TableDateCellComponent, {
        inputs: { value: (info.getValue() as number) * 1000 },
      }),
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.last_popup,
    id: 'last_popup',
    header: ({ column }) => ({
      content: 'Last Popup',
      onClick: () => column.toggleSorting(),
    }),
    cell: (info) =>
      flexRenderComponent(TableDateCellComponent, {
        inputs: { value: (info.getValue() as number) * 1000 },
      }),
    enableSorting: true,
  },
  {
    accessorFn: (row) => row?.link ?? '',
    id: 'link',
    header: ({ column }) => ({
      content: 'Link',
      onClick: () => column.toggleSorting(),
    }),
    cell: (info) => {
      const item = info.getValue() as string;
      if (!item) return '-';

      return flexRenderComponent(TableButtonCellComponent, {
        inputs: {
          text: 'Open',
          color: 'var(--purple)',
          textColor: 'var(--white)',
        },
        outputs: {
          handleClick: () => {
            window.open(item, '_blank');
          },
        },
      });
    },
    enableSorting: true,
  },
  {
    id: 'edit',
    header: () => 'Edit',
    cell: (cell) => {
      return flexRenderComponent(TableButtonCellComponent, {
        inputs: {
          text: 'Edit',
          color: 'var(--blue)',
          textColor: 'var(--white)',
        },
        outputs: {
          handleClick: () => {
            handleOpenEditModal(cell.row.original);
          },
        },
      });
    },
  },
  {
    id: 'actions',
    header: 'Actions',
    cell: (info) => {
      const item = info.row.original;
      return flexRenderComponent(TableButtonCellComponent, {
        inputs: {
          text: 'Remove',
          color: 'var(--red)',
          textColor: 'var(--black)',
        },
        outputs: {
          handleClick: () => handleRemoveItem(item),
        },
      });
    },
    enableSorting: false,
  },
];
